import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

const antIcon = <LoadingOutlined style={{ fontSize: "x-large", color: "#1890FF" }} spin />
const Spinner = () => <Spin indicator={antIcon} />

export default Spinner